import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

import carNums from '../components/store/carNums'; //引入某个store对象
import bindStudents from '../components/store/bindStudents'; //引入某个store对象
import user from '../components/store/user'; //引入某个store对象
import areaTeams from '../components/store/areaTeams'; //引入某个store对象
import group from '../components/store/group'; //引入某个store对象
import contract from '../components/store/contract'; //引入某个store对象

export default new vuex.Store({
    modules: {
        shopingCarNums: carNums,
        bindStudents: bindStudents,
        user: user,
        areaTeams: areaTeams,
        group: group,
        contract,
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js